import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { OrganizationNotifyType } from './organization-notify-type';

export class SnNotifyChannel extends SnModel {
  @Expose() public id: string;
  @Expose() public description: string;

  @Expose() @Type(() => Date) public createdTimestamp: Date;
  @Expose() @Type(() => Date) public updatedTimestamp: Date;

  @Expose() public phoneNumber: string;

  @Expose()
  @Type(() => OrganizationNotifyType)
  public organization: OrganizationNotifyType;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
